import { Button, Tabs } from "antd";
import React, { Component } from "react";
import HomeCourasel from "./HomeCourasel";
import HomeHeader from "./HomeHeader";
import HomeBanner from "./HomeBanner";
import HomeResults from "./HomeResults";
import Description from "../Description";
import Features from "../Features";
import { connect } from "react-redux";
import { loadUpcomingDraws } from "../../../redux/actions/sportTypesActions";
const TabPane = Tabs.TabPane;
const tabs = ["Home", "Lucky Numbers", "Next Draws", "Results", "How to play"];

export class Home extends Component {
  state = {
    currentFilter: 1,
    pageIndex: 0,
  };
  componentDidUpdate(prevProps) {
    const { match , upcomingDrawsEvents , luckyNumbersRefreshTime} = this.props;
    if (prevProps.upcomingDrawsEvents && prevProps.upcomingDrawsEvents !== upcomingDrawsEvents  && localStorage.getItem("refreshUpcomingDrawsEvents")) {
      clearTimeout(this.timeout)
      if(this.state.currentFilter == 1){
        this.timeout = setTimeout(()=>{
          let request = {
            Data: {
              Feed: { FeedId: Number(match.params.feed) },
              Sport: { SportId: Number(match.params.sport) },
              pageSize: 5,
              pageIndex: 0,
            },
          };
          this.props.loadUpcomingDraws(request , false);
          localStorage.removeItem("refreshUpcomingDrawsEvents")
          this.changePageIndex(0)
        },luckyNumbersRefreshTime * 1000)
      }else if (this.state.currentFilter == 2){
      
        this.timeout = setTimeout(()=>{
          let request = {
            Data: {
              isTopBet: true,
              Feed: { FeedId: Number(match.params.feed) },
              Sport: { SportId: Number(match.params.sport) },
              pageSize: 5,
              pageIndex: 0,
            },
          };
          this.props.loadUpcomingDraws(request , false);
          localStorage.removeItem("refreshUpcomingDrawsEvents")
          this.changePageIndex(0)
        },luckyNumbersRefreshTime * 1000)
      }else if (this.state.currentFilter == 3){
        this.timeout = setTimeout(()=>{
          let request = {
            Data: {
              isFavoriteTab: true,
              Feed: { FeedId: Number(match.params.feed) },
              Sport: { SportId: Number(match.params.sport) },
              pageSize: 5,
              pageIndex: 0,
            },
          };
          this.props.loadUpcomingDraws(request , false);
          localStorage.removeItem("refreshUpcomingDrawsEvents")
          this.changePageIndex(0)
        },luckyNumbersRefreshTime * 1000)
      }

    }
    if (!prevProps.connected && this.props.connected) {
      let request = {
        Data: {
          Feed: { FeedId: Number(match.params.feed) },
          Sport: { SportId: Number(match.params.sport) },
          pageSize: 5,
          pageIndex: 0,
        },
      };
      this.props.loadUpcomingDraws(request , false);
    }
  }
  
  componentDidMount() {
    const {
      loadUpcomingDraws,
      match,
      connected,
      GetLuckyNumberConfiguration,
    } = this.props;

    if (connected) {
      let request = {
        Data: {
          Feed: { FeedId: Number(match.params.feed) },
          Sport: { SportId: Number(match.params.sport) },
          pageSize: 5,
          pageIndex: 0,
        },
      };
      loadUpcomingDraws(request , false);
    }
  }
  componentWillUnmount(){
    clearTimeout(this.timeout)
    localStorage.removeItem("refreshUpcomingDrawsEvents")

  }
  onChangeFilter = (filter) => {
    this.setState({ currentFilter: filter });
  };
  changePageIndex= (value)=>{
    this.setState({
      pageIndex:value 
    })
  }
  render() {
    const {upcomingDrawsEvents}=this.props
    return (
      <div className="home-container">
        <HomeHeader
          match={this.props.match}
          history={this.props.history}
          onChangeFilter={this.onChangeFilter}
          currentFilter={this.state.currentFilter}
        />
        <HomeCourasel
          pageIndex={this.state.pageIndex}
          changePageIndex={this.changePageIndex}
          match={this.props.match}
          history={this.props.history}
          currentFilter={this.state.currentFilter}
        />
        <HomeBanner />
        <HomeResults fromResult={true} match={this.props.match} history={this.props.history} nav={this.props.nav}/>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    connected: state.signalr.luckyNumbersConnected,
    upcomingDrawsEvents: state.sportTypes.upcomingDrawsEvents,
    luckyNumbersRefreshTime: state.general.configuration.luckyNumbersRefreshTime,


  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadUpcomingDraws: (item , addNewList) => {
      dispatch(loadUpcomingDraws(item , addNewList));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
